import { Instance, Objekt } from '@siposdani87/sui-js';
import { app } from '../app';
import { AssetService } from './assetService';
import { BuildingService } from './buildingService';
import { DistrictService } from './districtService';
import { GroupService } from './groupService';
import { LanguageService } from './languageService';
import { PersonService } from './personService';
import { PlanPreyService } from './planPreyService';
import { PlanService } from './planService';
import { ReportService } from './reportService';
import { WildService } from './wildService';

export class ReportPersonService extends ReportService {
    static readonly inject = [
        'instances',
        'languageService',
        'assetService',
        'personService',
        'groupService',
        'buildingService',
        'districtService',
        'planService',
        'wildService',
        'planPreyService',
    ];

    constructor(
        instances: Instance,
        $languageService: LanguageService,
        $assetService: AssetService,
        $personService: PersonService,
        $groupService: GroupService,
        $buildingService: BuildingService,
        $districtService: DistrictService,
        $planService: PlanService,
        $wildService: WildService,
        $planPreyService: PlanPreyService,
    ) {
        super(
            instances,
            $languageService,
            $assetService,
            $personService,
            $groupService,
            $buildingService,
            $districtService,
            $planService,
            $wildService,
            $planPreyService,
        );
    }

    getTableCalculations() {
        return {
            ...this._getTableCalculations(),
            full_name: (object: Objekt) => {
                return this.helper.createLink(
                    object.get<string>('full_name'),
                    (href) => {
                        this.state.go(href);
                    },
                    this.state.resolveUrl('people.show', {
                        personId: [object.get<string>('id')],
                    }),
                );
            },
        };
    }
}

export const reportPersonService = app.service('reportPersonService', ReportPersonService);
